// @flow

import { useTranslator } from '@gandi/translate';
import { Base, Heading } from '@gandi/ui';

import type { BetterOfferResult } from '../../../modules/catalog';

export function DurationRowMultiyearPromo({
  basePercent,
  hookPercent,
  promoMinDuration,
}: BetterOfferResult): React.MixedElement | null {
  const { __ } = useTranslator();

  const shouldSplitMessage = basePercent > 0 && hookPercent <= 100;

  return (
    <Base flexAlignSelfStart>
      <Heading as="h4" fontSize="xs">
        {shouldSplitMessage
          ? __('Your loyalty rewarded: choose %(years)s years or more', {
              years: promoMinDuration,
            })
          : __('Your loyalty rewarded')}
      </Heading>
      <Base
        tagName="p"
        margin="none"
        size="small"
        color="promotional"
        weight="semibold"
      >
        {shouldSplitMessage
          ? __(
              '-%(hookPercent)s%% on year %(years)s, then -%(basePercent)s%% on subsequent years!',
              {
                years: promoMinDuration,
                hookPercent,
                basePercent,
              },
            )
          : __('Choose %(years)s years or more and save %(percent)s%%', {
              years: promoMinDuration,
              percent: basePercent,
            })}
      </Base>
    </Base>
  );
}
